import {AfterViewInit, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {HomeComponent} from "./home/home.component";
import {LoginComponent} from "./login/login.component";
import {CoreModule} from "../core/core.module";
import {UsuarioComponent} from './usuario/usuario.component';
import {CommonModule} from "@angular/common";
import {PlanoComponent} from './plano/plano.component';
import {ExecucaoPlanoComponent} from './execucao-plano/execucao-plano.component';
import {PlanosComponent} from './planos/planos.component';
import {MAT_CHECKBOX_CLICK_ACTION, MAT_DIALOG_DATA, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef} from "@angular/material";
import {GerencialPlanoComponent} from './gerencial-plano/gerencial-plano.component';
import {DialogMetaAcaoEstrategicaComponent} from "./dialogs/dialog-meta-acao-estrategica/dialog-meta-acao-estrategica.component";
import {DialogTextoAuxiliarComponent} from "./dialogs/dialog-texto-auxiliar/dialog-texto-auxiliar.component";
import {ConsultarMinutaComponent} from './consultar-minuta/consultar-minuta.component';
import {DialogConfirmarSairComponent} from "./dialogs/dialog-confirmar-sair/dialog-confirmar-sair.component";
import {DialogSolicitarAcessoComponent} from './dialogs/dialog-solicitar-acesso/dialog-solicitar-acesso.component';
import {EsqueciMinhaSenhaComponent} from './esqueci-minha-senha/esqueci-minha-senha.component';
import {PerfilComponent} from './perfil/perfil.component';
import {UsuariosComponent} from './usuarios/usuarios.component';
import {DialogPlanoGestorComponent} from './dialogs/dialog-plano-gestor/dialog-plano-gestor.component';
import {DialogConfirmarExclusaoMetaAcaoEstrategicaComponent} from './dialogs/dialog-confirmar-exclusao-meta-acao-estrategica/dialog-confirmar-exclusao-meta-acao-estrategica.component';
import {DialogLogoutComponent} from './dialogs/dialog-logout/dialog-logout.component';
import {EditorModule} from '@tinymce/tinymce-angular';
import {NgxFileDropModule} from "ngx-file-drop";
import {DialogTextoAnexoComponent} from "./dialogs/dialog-texto-anexo/dialog-texto-anexo.component";
import {MatPaginatorModule} from '@angular/material';
import {DialogConfirmarExclusaoAnexoComponent} from "./dialogs/dialog-confirmar-exclusao-anexo/dialog-confirmar-exclusao-anexo.component";
import {MatRadioModule} from '@angular/material/radio';
import {LoginExternoComponent} from "./login-externo/login-externo.component";
import {CadastroExternoComponent} from "./cadastro-externo/cadastro-externo.component";
import {UsuarioExternoComponent} from "./usuario-externo/usuario-externo.component";
import {ReactiveFormsModule} from "@angular/forms";
import {DialogUsuarioExternoComponent} from "./dialogs/dialog-usuario-externo/dialog-usuario-externo.component";
import {AvaliarCadastroExternoComponent} from "./avaliar-cadastro-externo/avaliar-cadastro-externo.component";
import {DialogRecusaAtivacaoUsuarioComponent} from "./dialogs/dialog-recusa-ativacao-usuario/dialog-recusa-ativacao-usuario.component";
import {VisualizarCadastroExternoComponent} from "./visualizar-cadastro-externo/visualizar-cadastro-externo.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {CompletarCadastroAdComponent} from "./CompletarCadastroAd/completar-cadastro-ad.component";


@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        EditorModule,
        NgxFileDropModule,
        MatPaginatorModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatExpansionModule,
    ],
    declarations: [
        HomeComponent,
        LoginComponent,
        UsuarioComponent,
        PlanoComponent,
        ExecucaoPlanoComponent,
        PlanosComponent,
        DialogMetaAcaoEstrategicaComponent,
        DialogTextoAuxiliarComponent,
        DialogTextoAnexoComponent,
        DialogConfirmarExclusaoAnexoComponent,
        DialogConfirmarSairComponent,
        DialogSolicitarAcessoComponent,
        DialogUsuarioExternoComponent,
        GerencialPlanoComponent,
        UsuarioExternoComponent,
        ConsultarMinutaComponent,
        EsqueciMinhaSenhaComponent,
        DialogRecusaAtivacaoUsuarioComponent,
        PerfilComponent,
        UsuariosComponent,
        AvaliarCadastroExternoComponent,
        LoginExternoComponent,
        DialogSolicitarAcessoComponent,
        CadastroExternoComponent,
        DialogPlanoGestorComponent,
        DialogConfirmarExclusaoMetaAcaoEstrategicaComponent,
        DialogLogoutComponent,
        VisualizarCadastroExternoComponent,
        CompletarCadastroAdComponent,
    ],
    exports: [
        MatPaginatorModule
    ],
    entryComponents: [DialogMetaAcaoEstrategicaComponent, DialogRecusaAtivacaoUsuarioComponent, DialogUsuarioExternoComponent, DialogConfirmarExclusaoAnexoComponent, DialogTextoAuxiliarComponent, DialogConfirmarSairComponent, DialogSolicitarAcessoComponent, DialogPlanoGestorComponent, DialogConfirmarExclusaoMetaAcaoEstrategicaComponent, DialogLogoutComponent, DialogTextoAnexoComponent],
    providers: [
        {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'},
        {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {'hasBackdrop': true}},
        {provide: MAT_DIALOG_DATA, useValue: {}},
        {provide: MatDialogRef, useValue: {}}
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {

}
